<template>
    <div>
        <rkm-area
            background-color="primary"
            closed
            title="Procedimentos cirúrgicos"
            type="box"
        >
            <rkm-list
                :items="data.form.solicitacoesProcedimentosCirurgicos"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <rkm-row>
                        <rkm-col cols="6">
                            <strong>CID 10</strong><br />{{item.cidDescricao ?? '-'}}
                        </rkm-col>

                        <rkm-col cols="6">
                            <strong>CIAP 2</strong><br />{{item.ciapDescricao ?? '-'}}
                        </rkm-col>

                        <rkm-col cols="12">
                            <strong>Justificativa do procedimento</strong><br />{{item.justificativa}}
                        </rkm-col>

                        <rkm-col cols="12">
                            <strong>Observações</strong><br />{{item.observacao}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:collapse="{item}">
                    <div class="p-2">
                        <rkm-row>
                            <rkm-col>
                                <rkm-table
                                    :fields="fields"
                                    :items="item.procedimentosCirurgicos"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(procedimentoCirurgico)="{item}">
                                        {{item.descricao}}
                                    </template>
                                </rkm-table>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </template>
            </rkm-list>
        </rkm-area>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fields: [
                {key: 'procedimentoCirurgico', label: 'Procedimento cirúrgico', sortable: true},
            ],
        }
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>